// GETTERS
export const GET_REMINDER = 'reminder/GET_REMINDER';
export const GET_REMINDER_LIST = 'reminder/GET_REMINDER_LIST';


// MUTATORS
export const MUTATE_LIST_REMINDER = 'reminder/MUTATE_LIST_REMINDER';


// ACTIONS
export const ACTION_LIST_REMINDERS = 'reminder/ACTION_LIST_REMINDERS';
export const ACTION_ADD = 'reminder/ACTION_ADD';
export const ACTION_DELETE = 'reminder/ACTION_DELETE';
export const ACTION_UPDATE = 'reminder/ACTION_UPDATE';





// WEBPACK FOOTER //
// ./src/store/constants/reminder.js